/**
 * The discount block's fixed chrome — the words neither bundle lets the merchant change.
 *
 * A module of its own, and NubeSDK-free on purpose: `blocks.ts` (where these used to live) imports
 * `@tiendanube/nube-sdk-ui`, so re-exporting them through `@cod/form-tree/pure` would have dragged
 * the SDK into the legacy IIFE. `pure.test.ts` caught exactly that and is why this file exists.
 *
 * Only the two ERROR strings (`invalid_error`, `limit_error`) are Designer settings; everything
 * else the discount row says is chrome, the same on every store.
 */
/** Prefix of the confirmation line: `Cupon aplicado: -$10.00`. */
export const DISCOUNT_APPLIED_PREFIX = 'Cupon aplicado';
/**
 * What the Apply button says once a code is on, and what pressing it then does.
 *
 * 🚨 The SDK path had no way OUT of an applied code: the button re-validated the code that was
 * already applied, so a buyer who entered one coupon could not swap it for a better one. The
 * legacy path could remove it, but only by accident — its label was left on the `...` loading
 * placeholder after a successful apply, because nothing reset it, so the affordance existed and
 * was unreadable. Both now toggle to this word.
 */
export const DISCOUNT_REMOVE_TEXT = 'Quitar';
//# sourceMappingURL=strings.js.map